<template>
  <div>
    <TitleBar v-if="$route.path.includes('control-panel')">
      <template v-slot:title>
        <span v-translate>Export</span>
      </template>
    </TitleBar>

    <div class="setting-content--section">
      <b-form class="form-horizontal" @submit="onSubmit">
        <p>
          <translate>You can download all your Gekko data at any time. The resulting ZIP file will contain all your invoices, costs, and overviews of both in (Excel compatible) CSV format. Your accounts will remain available online.</translate>
        </p>
        <b-row>
          <b-col cols="4">
            <div class="form-group">
              <label><translate>Select a year</translate></label>
              <b-form-select v-model="form.selectedYear" :options="optionsYear"> </b-form-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <div class="form-group">
              <label><translate>Select a quarter</translate></label>
              <b-form-select v-model="form.selectedQuarter" :options="optionsQuarter"> </b-form-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <div class="form-group">
              <GekkoButton
                :text="$gettext('Download')"
                icon="fa-solid fa-download"
                type="submit"
                class="position-relative"
                :disabled="isButtonDisabled"
                :loading="isButtonDisabled"
              />
            </div>
          </b-col>
        </b-row>
        <div v-if="isButtonDisabled" class="text-warning">
          {{ $gettext('Please wait 10 minutes before attempting to download your data again.') }}
        </div>
        <div v-if="isButtonDisabled">
          {{ $gettext('Your download is being prepared, check your downloads page to download the file.') }}
          <GekkoButton
            :href="filesPageUrl"
            :text="$gettext('Go to downloads')"
            icon="fa-solid fa-arrow-right"
            icon-right
            variant="link"
            class="px-0"
          />
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/store/services/company.service.js'
import GekkoButton from '@/components/GekkoButton'
import TitleBar from '@/components/TitleBar'
import { mapGetters } from 'vuex'
// mixins
import settingsPageSetup from '@/mixins/settingsPageSetup'

export default {
  name: 'DownloadData',
  components: { GekkoButton, TitleBar },
  mixins: [settingsPageSetup],
  data() {
    return {
      buttonDisabled: false,
      pageSettings: {
        title: this.$gettext('Download your data'),
        showCompanyPicker: true,
      },
      company: null,
      optionsYear: [],
      optionsQuarter: [
        { value: null, text: 'All' },
        { value: 'Q1', text: 'Q1' },
        { value: 'Q2', text: 'Q2' },
        { value: 'Q3', text: 'Q3' },
        { value: 'Q4', text: 'Q4' },
      ],
      form: {
        selectedYear: null,
        selectedQuarter: null,
      },
    }
  },
  computed: {
    isButtonDisabled() {
      return this.buttonDisabled || this.$cookies.get('disable_download_data_button') === 'true'
    },
    ...mapGetters({
      getCompanyId: 'main/getCompanyId'
    }),
    filesPageUrl() {
      if (this.$route.name === "ControlPanelExport") {
        return this.Urls['accountants:files'](this.getCompanyId)
      } else {
        return this.Urls['accounts_files']()
      }
    }
  },
  created() {
    this.setupData()
  },
  methods: {
    setupData() {
      this.buttonDisabled = this.$cookies.get('disable_download_data_button') === 'true'
      CompanyService.financiallyActiveYears(this.getCompanyId).then((response) => {
        var raw = response.data
        var processed = []

        var firstOption = { value: null, text: 'All' }
        processed.push(firstOption)
        raw.forEach((element) => {
          processed.push({ value: element, text: element })
        })
        this.optionsYear = processed
      })
    },
    onSubmit(event) {
      this.buttonDisabled = true
      event.preventDefault()
      CompanyService.downloadData(this.getCompanyId, {
        year: this.form.selectedYear,
        quarter: this.form.selectedQuarter,
      })
        .then((response) => {
          var expiry_date = new Date()
          expiry_date.setSeconds(expiry_date.getSeconds() + 10 * 60)
          this.$cookies.set('disable_download_data_button', true, expiry_date)
          switch (response.status) {
            case 200:
              this.$store.commit('setAlert', {
                title: this.$gettext('Data downloaded'),
                text: this.$gettext('Your downloaded data will be sent in an e-mail. This might take a few minutes.'),
                duration: 4,
              })

              window.location.href = this.filesPageUrl

              break
            case 204:
              this.$store.commit('setAlert', {
                title: this.$gettext('No data available for download'),
                text: this.$gettext(
                  "You don't have any data to be downloaded. Try adding invoices, costs, suppliers or trips."
                ),
                variant: 'danger',
                duration: 4,
              })
              break
            case 500:
              this.$store.commit('setAlert', {
                title: this.$gettext('Error downloading data'),
                text: this.$gettext(
                  'Something went wrong when trying to fetch and download your data. Please try again later.'
                ),
                variant: 'danger',
                duration: 4,
              })
              break
          }
        })
        .catch((response) => {
          if (response.status === 496) {
            this.$store.commit('setAlert', {
              title: this.$gettext('Error downloading data'),
              text: this.$gettext('You do not have access to this data.'),
              variant: 'danger',
              duration: 4,
            })
          }
        })
    },
  },
}
</script>